<fui-date-control [disabled]="isReadonly" [label]="label" [placeholder]="placeholder" [attr.id]="elementId"
                  [(ngModel)]="value" [control]="formControl">
</fui-date-control>
